export const POST_TYPE = {
  question: '질문&답변',
  study: '스터디',
  chat: '고민있어요',
  PROJECT: '팀프로젝트',
  ANSWER: '질문&답변',
} as const;

export const POST_STATUS = {
  resolved: '해결됨',
  unresolved: '미해결',
  recruited: '모집완료',
  unrecruited: '모집중',
} as const;

export const POST_SORT = {
  RECENT: {
    label: '최신순',
    value: 'RECENT',
  },
  OLDER: {
    label: '오래된순',
    value: 'OLDER',
  },
  RECOMMEND: {
    label: '좋아요순',
    value: 'RECOMMEND',
  },
} as const;

export const POST_FILTER = {
  ALL: {
    label: '전체',
    value: 'ALL',
  },
  ANSWER: {
    label: '질문&답변',
    value: 'ANSWER',
  },
  CHAT: {
    label: '고민있어요',
    value: 'CHAT',
  },
  STUDY: {
    label: '스터디',
    value: 'STUDY',
  },
  PROJECT: {
    label: '팀프로젝트',
    value: 'PROJECT',
  },
} as const;
